module.exports = __webpack_public_path__ + "static/media/menu.03316852.svg";